/* @flow */

import * as React from 'react';

import { Button, ButtonIcon, Footer, Page, PageContainer, genRuby } from '@sonyged/ext-proc';

import type { FinishedRound } from './domain/Round';
import { ingredientIcon } from './domain/pizza';

type Props = {
  round: FinishedRound,
  onBack?: () => void,
  onNext: () => void,
  changable: 'all' | 'topping' | 'crust' | 'sauce',
  onChange: ('all' | 'topping' | 'crust' | 'sauce') => void,
};

class PizzaSetChangableView extends React.Component<Props> {
  renderHint() {
    if (this.props.changable === 'crust') {
      return 'どのくらい おなかが へって いるかに ヒントが あるよ。';
    } else if (this.props.changable === 'sauce') {
      return 'トッピングに [合|あ]う ソースが あるよ。';
    } else {
      return 'おきゃくさんの セリフに ヒントが あるよ。';
    }
  }

  render() {
    return (
      <div className="pizza-research-topview gray5-bg-color">
        <Page.normal>
          <PageContainer.normal className="flex flex-column">
            <div className="pizza-research-topview-content">
              <div className="title">
                <div className="proc-medium-font secondary100-color">しらべる</div>
                <div className="proc-huge-font secondary100-color">ひとつだけ かえて みよう</div>
              </div>

              <div className={`proc-image-selection-container white`}>
                <div
                  className={`images-container relative white-after-border-bottom-color ${
                    this.props.changable === 'crust' ? 'selected' : ''
                  }`}
                >
                  <img
                    src={ingredientIcon(this.props.round.pizza.crust)}
                    className={`image ${this.props.changable === 'crust' ? 'selected' : ''}`}
                    onClick={this.props.changable === 'crust' ? null : () => this.props.onChange('crust')}
                  />
                  <div className={'title proc-small-font'}>ピザきじ</div>
                </div>
                <div
                  className={`images-container relative white-after-border-bottom-color ${
                    this.props.changable === 'sauce' ? 'selected' : ''
                  }`}
                >
                  <img
                    src={ingredientIcon(this.props.round.pizza.sauce)}
                    className={`image ${this.props.changable === 'sauce' ? 'selected' : ''}`}
                    onClick={this.props.changable === 'sauce' ? null : () => this.props.onChange('sauce')}
                  />
                  <div className={'title proc-small-font'}>ソース</div>
                </div>
                <div
                  className={`images-container relative white-after-border-bottom-color ${
                    this.props.changable === 'topping' ? 'selected' : ''
                  }`}
                >
                  <div
                    className={`image topping-images-container ${this.props.changable === 'topping' ? 'selected' : ''}`}
                    onClick={this.props.changable === 'topping' ? null : () => this.props.onChange('topping')}
                  >
                    {this.props.round.pizza.toppings.map((topping, index) => {
                      return (
                        <img
                          key={`topping-${index}`}
                          className={`topping-${index + 1}`}
                          src={ingredientIcon(topping)}
                        />
                      );
                    })}
                  </div>
                  <div className={'title proc-small-font'}>トッピング</div>
                </div>
              </div>

              <div className={'hint proc-small-font white-bg-color gray100-color'}>{genRuby(this.renderHint())}</div>
            </div>
          </PageContainer.normal>
        </Page.normal>
        <Footer.nav
          shadow={false}
          navItem={
            this.props.onBack ? (
              <Button.normal onClick={this.props.onBack}>
                <ButtonIcon.back />
              </Button.normal>
            ) : null
          }
        >
          <Button.attention onClick={this.props.onNext}>つぎへ</Button.attention>
        </Footer.nav>
      </div>
    );
  }
}

export default PizzaSetChangableView;
